import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from './resume.pdf';

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>My Awesome</span>
        <span>services</span>
        <spane>
        As a software engineer, I provide comprehensive software development 
        services spanning both <br />
        front-end and back-end technologies. With expertise in a range of programming languages, frameworks, and
        <br />
        databases, I deliver tailored solutions for web and mobile 
        applications. From conceptualization to deployment, 
        <br />I specialize in crafting intuitive user interfaces, robust server-side architecture,
        <br /> efficient databases, and seamless integrations. My portfolio 
        showcases a diverse array of projects
        <br /> reflecting my commitment to quality, 
        innovation, and client satisfaction.
        
        </spane>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Languages / Framework"}
            detail={"Html, Css, JavaScript, React.js, Nodejs, NestJs, GraphQL, PHP, Laravel..."}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"Database / Mobile Dev & OS"}
            detail={"PostgreSQL, MySQL, MongoDB , Flutter & React Native, Linux & Windows"}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Other Tools / Version Control"}
            detail={
              "Git/ GitHub, Docker, Firebase, Adobe Photoshop, WordPress"
            }
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
